import React from 'react'
import { formatSalesValue } from './../../utils/formatUtils';

const TotalSale = ({ totalSaleSummary }) => {
  let revenuePerGuest = parseFloat(totalSaleSummary?.RevenuePerGuest)

  return (
    <div className='total-sale-summary p-3 space-y-3'>
      <div><span>Total PAX : </span>{totalSaleSummary?.totalPax} </div>
      <div><span>Total Net Sale : </span>{formatSalesValue(totalSaleSummary?.totalNetSales)} </div>
      <div><span>Total Dine-In : </span>{formatSalesValue(totalSaleSummary?.TotalDineIn)} </div>
      <div><span>Total Take-away : </span>{formatSalesValue(totalSaleSummary?.TotalTab)} </div>
      <div><span>Revenue Per Guest : </span>{formatSalesValue(revenuePerGuest)} </div>
    </div>
  )
}

export default TotalSale